import React from "react";
import { Typography, Box, useTheme } from "@mui/material";

const PageSection = ({
  title,
  children,
}: {
  title: React.ReactNode;
  children: React.ReactNode;
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        bgcolor: theme.palette.background.paper,
        p: { xs: 2, sm: 3 },
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 500 }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
};

export default PageSection;
